$(document).on("turbolinks:load", function () {
  var placeholderText = "Search..."

  // multi‐selects
  $(".js-select-multi").select2({
    multiple: true,
    width: "100%",
  })

  function initializeSelect2(selectElement) {
    var $selectElement = $(selectElement)
    var options = { width: "100%" }

    // Bootstrap's modal focus trap yanks focus away from anything appended to
    // <body>, making the search box untypeable — render the dropdown inside
    // the modal instead.
    var modal = selectElement.closest(".modal")
    if (modal) options.dropdownParent = $(modal)

    if ($selectElement.data("url")) {
      $selectElement.select2(
        $.extend(options, {
          ajax: {
            url: $selectElement.data("url"),
            dataType: "json",
            delay: 250,
            data: function (params) {
              return { q: params.term }
            },
            processResults: function (data) {
              return { results: data.results }
            },
            cache: true,
          },
          minimumInputLength: 3,
          placeholder: placeholderText,
        })
      )
    } else {
      $selectElement.select2(options)
    }
  }

  // initialize on page load
  $(".js-select, .js-input-select").each(function () {
    initializeSelect2(this)
  })

  // initialize on cocoon:after-insert
  $(document).on("cocoon:after-insert", function (e, insertedItem) {
    $(insertedItem)
      .find(".js-select, .js-input-select")
      .each(function () {
        initializeSelect2(this)
      })
  })

  // destroy before Turbolinks caches
  $(document).one("turbolinks:before-cache", function () {
    $(".select2-hidden-accessible").each(function () {
      $(this).select2("destroy")
    })
  })
})
